(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cat-product"]) return;
  try {
    
document.querySelectorAll('.cat-page').forEach(page=>{const main=page.querySelector('[data-cat-main]');const overview=page.querySelector('[data-cat-overview]');const markPhoto=button=>page.querySelectorAll('.cat-thumbs button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));page.querySelectorAll('[data-cat-photo]').forEach(b=>b.addEventListener('click',()=>{main.src=b.dataset.catPhoto;markPhoto(b);}));overview.addEventListener('click',()=>{main.src=page.querySelector('.cat-form select').selectedOptions[0].dataset.image;markPhoto(overview);});const form=page.querySelector('.cat-form');const qty=form.querySelector('[name=quantity]');const minus=form.querySelector('[data-cat-step="-1"]');const normalize=()=>{qty.value=String(Math.max(1,Math.floor(Number(qty.value)||1)));minus.disabled=Number(qty.value)<=1;};form.querySelectorAll('[data-cat-step]').forEach(b=>b.addEventListener('click',()=>{normalize();qty.value=String(Math.max(1,Number(qty.value)+Number(b.dataset.catStep)));normalize();qty.dispatchEvent(new Event('change',{bubbles:true}));}));qty.addEventListener('change',normalize);page.querySelectorAll('[data-cat-variant]').forEach(b=>b.addEventListener('click',()=>{const select=form.querySelector('select');select.value=b.dataset.catVariant;select.dispatchEvent(new Event('change',{bubbles:true}));}));form.querySelector('select').addEventListener('change',event=>{const option=event.target.selectedOptions[0];page.querySelector('[data-cat-color]').textContent=option.textContent;page.querySelectorAll('[data-cat-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.catVariant===option.value)));page.querySelector('[data-cat-price]').textContent=option.dataset.price;const available=option.dataset.available==='true';form.querySelector('[type=submit]').disabled=!available;form.querySelector('[type=submit] span').textContent=available?'Add to bag':'Sold out';form.querySelector('.cat-express').hidden=!available;if(option.dataset.image){main.src=option.dataset.image;const thumb=overview.querySelector('img');thumb.src=option.dataset.image;thumb.removeAttribute('srcset');markPhoto(overview);}const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corner-brush-product"]) return;
  try {
    
document.querySelectorAll('.brush-page').forEach(page=>{const main=page.querySelector('[data-brush-main]');page.querySelectorAll('[data-brush-photo]').forEach(b=>b.addEventListener('click',()=>{main.src=b.dataset.brushPhoto;main.alt=b.dataset.brushAlt;page.querySelectorAll('[data-brush-photo]').forEach(t=>t.setAttribute('aria-pressed',String(t===b)));}));const form=page.querySelector('.brush-form'),qty=form.querySelector('[name=quantity]'),minus=form.querySelector('[data-brush-step="-1"]');const normalize=()=>{qty.value=String(Math.max(1,Math.floor(Number(qty.value)||1)));minus.disabled=Number(qty.value)<=1;const count=Number(qty.value);page.querySelector("[data-brush-pack-count]").textContent=count+" "+(count===1?"pack":"packs")+" = "+(count*2)+" brushes";};form.querySelectorAll('[data-brush-step]').forEach(b=>b.addEventListener('click',()=>{normalize();qty.value=String(Math.max(1,Number(qty.value)+Number(b.dataset.brushStep)));normalize();qty.dispatchEvent(new Event('change',{bubbles:true}));}));qty.addEventListener('change',normalize);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-page-footer"]) return;
  try {
    
document.querySelectorAll('.pet-related-form').forEach(form=>{const card=form.closest('.pet-related-card'),select=form.querySelector('select'),button=form.querySelector('button[type=submit]'),status=form.querySelector('[role=status]');if(select)select.addEventListener('change',()=>{card.querySelector('[data-related-price]').textContent=select.selectedOptions[0].dataset.price;status.textContent='';});form.addEventListener('submit',async event=>{if(!window.fetch)return;event.preventDefault();button.disabled=true;button.textContent='Adding…';status.textContent='';try{const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw new Error(result.description||'Could not add this item. Please try again.');status.textContent='Added to your bag.';button.textContent='Added ✓';fetch(window.Shopify.routes.root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(cart=>document.querySelectorAll('.play-bag span').forEach(badge=>badge.textContent=String(cart.item_count))).catch(()=>{});}catch(error){status.textContent=error.message||'Could not add this item. Please try again.';button.textContent='Add to bag +';}finally{button.disabled=false;}});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-product"]) return;
  try {
    
document.querySelectorAll('.pet-item-form').forEach(form=>{
 const select=form.querySelector('select');
 const quantity=form.querySelector('[name="quantity"]');
 const minus=form.querySelector('[data-quantity-step="-1"]');
 const normalizeQuantity=()=>{const value=Number(quantity.value);quantity.value=String(Number.isFinite(value)?Math.max(1,Math.floor(value)):1);minus.disabled=Number(quantity.value)<=1;};
 quantity.addEventListener('input',()=>{minus.disabled=Number(quantity.value)<=1;});
 quantity.addEventListener('change',normalizeQuantity);
 form.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{normalizeQuantity();quantity.value=String(Math.max(1,Number(quantity.value)+Number(button.dataset.quantityStep)));quantity.dispatchEvent(new Event('input',{bubbles:true}));quantity.dispatchEvent(new Event('change',{bubbles:true}));}));
 const choices=[...form.querySelectorAll('[data-pet-variant]')];
 if(choices.length)form.classList.add('has-color-picker');
 const update=(changeImage=false)=>{
  const option=select.selectedOptions[0];
  const info=form.closest('.pet-product-information');
  const button=form.querySelector('button[type="submit"]');
  const available=option.dataset.available==='true';
  button.disabled=!available;
  const express=form.querySelector("[data-pet-express]");if(express)express.hidden=!available;
  button.querySelector('[data-pet-button-label]').textContent=available?button.dataset.addLabel:button.dataset.soldLabel;
  info.querySelector('[data-pet-price]').textContent=option.dataset.price;
  const chosen=choices.find(choice=>choice.dataset.petVariant===select.value);
  if(chosen)info.dataset.petAccent=chosen.dataset.colorLabel.toLowerCase();
  choices.forEach(choice=>choice.setAttribute('aria-pressed',String(choice===chosen)));
  if(chosen)form.querySelector('[data-pet-color-name]').textContent=chosen.dataset.colorLabel;
  const stock=form.querySelector('[data-pet-color-stock]');
  if(stock)stock.textContent=available?'':button.dataset.soldLabel;
  if(changeImage&&option.dataset.image){
   const image=info.closest('.pet-product-detail').querySelector('.pet-main-product-image');
   if(image){image.removeAttribute('srcset');image.src=option.dataset.image;image.alt=chosen?chosen.dataset.colorLabel:image.alt;}
   info.closest('.pet-product-detail').querySelectorAll('[data-pet-image]').forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb.dataset.petImage===option.dataset.image)));
  }
 };
 select.addEventListener('change',()=>{update(true);const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);});
 choices.forEach(choice=>choice.addEventListener('click',()=>{select.value=choice.dataset.petVariant;select.dispatchEvent(new Event('change',{bubbles:true}));}));
 update();
});

document.querySelectorAll('[data-pet-gallery]').forEach(gallery=>{gallery.querySelectorAll('[data-pet-image]').forEach(button=>{button.addEventListener('click',()=>{const image=gallery.querySelector('.pet-main-product-image');if(!image)return;const select=gallery.closest('.pet-product-detail').querySelector('.pet-item-form select');const option=select&&[...select.options].find(option=>option.dataset.image===button.dataset.petImage);if(option){select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));}image.srcset=button.dataset.petSrcset;image.src=button.dataset.petImage;gallery.querySelectorAll('[data-pet-image]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));const count=gallery.querySelector('[data-pet-gallery-count]');if(count)count.textContent=String([...gallery.querySelectorAll('[data-pet-image]')].indexOf(button)+1).padStart(2,'0')+' / '+String(gallery.querySelectorAll('[data-pet-image]').length).padStart(2,'0');});});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-video-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-video-reviews]').forEach(section=>{const dialog=section.querySelector('dialog');const video=dialog.querySelector('video');section.querySelectorAll('[data-video-src]').forEach(button=>button.addEventListener('click',()=>{video.src=button.dataset.videoSrc;video.poster=button.dataset.videoPoster;dialog.showModal();video.play().catch(()=>{});}));dialog.querySelector('.pet-video-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}});dialog.addEventListener('close',()=>{video.pause();video.removeAttribute('src');video.load();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treat-balls-product"]) return;
  try {
    
document.querySelectorAll('.treat-page').forEach(page=>{const main=page.querySelector('[data-treat-main]'),form=page.querySelector('.treat-form'),select=form.querySelector('select'),qty=form.querySelector('[name=quantity]'),minus=form.querySelector('[data-treat-step="-1"]');const markPhoto=button=>page.querySelectorAll('.treat-thumbs button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));const summary=()=>{const packs=Math.max(1,Math.floor(Number(qty.value)||1));qty.value=String(packs);minus.disabled=packs<=1;const balls=packs*Number(select.selectedOptions[0].dataset.count);page.querySelector('[data-treat-pack-note]').textContent=packs+' '+(packs===1?'pack':'packs')+' = '+balls+' balls · Random colors';};page.querySelectorAll('[data-treat-photo]').forEach(b=>b.addEventListener('click',()=>{main.src=b.dataset.treatPhoto;main.alt=b.getAttribute('aria-label');markPhoto(b);}));form.querySelectorAll('[data-treat-step]').forEach(b=>b.addEventListener('click',()=>{summary();qty.value=String(Math.max(1,Number(qty.value)+Number(b.dataset.treatStep)));summary();qty.dispatchEvent(new Event('change',{bubbles:true}));}));qty.addEventListener('change',summary);page.querySelectorAll('[data-treat-variant]').forEach(b=>b.addEventListener('click',()=>{select.value=b.dataset.treatVariant;select.dispatchEvent(new Event('change',{bubbles:true}));}));select.addEventListener('change',()=>{const option=select.selectedOptions[0];page.querySelectorAll('[data-treat-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.treatVariant===option.value)));page.querySelector('[data-treat-price]').textContent=option.dataset.price;const available=option.dataset.available==='true';form.querySelector('[type=submit]').disabled=!available;form.querySelector('[type=submit] span').textContent=available?'Add to bag':'Sold out';form.querySelector('.treat-express').hidden=!available;main.src=option.dataset.image;main.alt=option.textContent;markPhoto(null);summary();const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);});summary();});

  } catch(e) { console.error(e); }
})();
})();
